import { Component } from '@angular/core';
import { LanguageDropDownService } from '@navigation';
import { States, StateService } from '@state';

@Component({
    selector: 'cl-header-minimal',
    template: `
	<header>
		<input type="checkbox" id="responsive-navi-toggle">
		<a class="logo" href="#/Login">&nbsp;</a>
		<responsive-button show-on="phone small-tablet"></responsive-button>
	</header>
	`,
    standalone: false
})
export class CLHeaderMinimal {
	constructor(private stateService: StateService, public language: LanguageDropDownService){}

	public isLoggedIn : boolean = false;

	public ngAfterViewInit(){
		this.stateService.values([States.isLoggedIn]).subscribe((values) => {
			this.isLoggedIn = !!values.isLoggedIn;
		});
	}
}